/**
 * 响应包装中间件
 * 统一 API 响应格式
 */

import { Request, Response, NextFunction } from 'express';
import type { ApiResponse } from '../types.js';
import { ProjectConfigManager } from '../../core/project-config.js';
import path from 'path';

declare global {
  namespace Express {
    interface Response {
      success: (data?: any, meta?: any) => void;
      error: (code: string, message: string, statusCode?: number, details?: any) => void;
      paginate: (data: any[], pagination: any) => void;
    }
  }
}

export function responseWrapper(req: Request, res: Response, next: NextFunction): void {
  // 成功响应
  res.success = async function(data?: any, meta?: any) {
    // Try to get project info
    let projectInfo = null;
    try {
      const workflowDir = path.join(process.cwd(), '.workflow');
      const projectConfig = new ProjectConfigManager(workflowDir);
      projectInfo = await projectConfig.getProjectInfo();
    } catch {
      // Ignore errors, project info is optional
    }

    const response: ApiResponse = {
      success: true,
      data,
      meta: {
        timestamp: new Date().toISOString(),
        version: req.headers['x-api-version'] as string || 'v2',
        project: projectInfo,
        ...meta,
      },
    };
    res.json(response);
  };

  // 错误响应
  res.error = async function(code: string, message: string, statusCode = 400, details?: any) {
    // Try to get project info
    let projectInfo = null;
    try {
      const workflowDir = path.join(process.cwd(), '.workflow');
      const projectConfig = new ProjectConfigManager(workflowDir);
      projectInfo = await projectConfig.getProjectInfo();
    } catch {
      // Ignore errors, project info is optional
    }

    const response: ApiResponse = {
      success: false,
      error: {
        code,
        message,
        details,
      },
      meta: {
        timestamp: new Date().toISOString(),
        version: req.headers['x-api-version'] as string || 'v2',
        project: projectInfo,
      },
    };
    res.status(statusCode).json(response);
  };

  // 分页响应
  res.paginate = async function(data: any[], pagination: any) {
    // Try to get project info
    let projectInfo = null;
    try {
      const workflowDir = path.join(process.cwd(), '.workflow');
      const projectConfig = new ProjectConfigManager(workflowDir);
      projectInfo = await projectConfig.getProjectInfo();
    } catch {
      // Ignore errors, project info is optional
    }

    const response = {
      success: true,
      data,
      pagination,
      meta: {
        timestamp: new Date().toISOString(),
        version: req.headers['x-api-version'] as string || 'v2',
        project: projectInfo,
      },
    };
    res.json(response);
  };

  next();
}